import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Fängt Render-Fehler, damit die App nicht auf einem weißen Bildschirm endet.
 */
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Uncaught UI error', error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary medieval">
          <h1>Etwas ist schiefgelaufen</h1>
          <p>Die Oberfläche hat einen unerwarteten Fehler. Ein Neuladen stellt den letzten Stand meist wieder her.</p>
          <button type="button" className="medieval-button" onClick={this.handleReload}>
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
